export interface BillingTimelineEvent {
  type: 'insurance_verification' | 'external_policy_verification' | 'external_verification';
  id: string;
}

export interface BillingTimelineTarget {
  targetDate?: string | null;
  event?: BillingTimelineEvent | null;
}

const DEFAULT_WINDOW_MONTHS = 6;

const toIsoDate = (date: Date) => date.toISOString().split('T')[0];

const defaultWindowStart = (now: Date) => {
  const start = new Date(now);
  start.setMonth(start.getMonth() - DEFAULT_WINDOW_MONTHS);
  return toIsoDate(start);
};

const dayBefore = (date: Date) => {
  const previous = new Date(date);
  previous.setDate(previous.getDate() - 1);
  return toIsoDate(previous);
};

export const billingTimelineEventToken = ({ type, id }: BillingTimelineEvent) => {
  switch (type) {
    case 'external_policy_verification':
      return `external_policy_verification:epv:${id}`;
    case 'external_verification':
      return `external_policy_verification:ev:${id}`;
    default:
      return `insurance_verification:${id}`;
  }
};

export const buildBillingTimelineUrl = ({
  personId,
  policyId,
  targetDate,
  event,
  now = new Date()
}: {
  personId: string;
  policyId?: string;
  now?: Date;
} & BillingTimelineTarget): string => {
  const params = new URLSearchParams();
  if (policyId) params.set('policy', policyId);

  if (targetDate) {
    const target = new Date(targetDate);
    if (!Number.isNaN(target.getTime())) {
      const start = dayBefore(target);
      if (start < defaultWindowStart(now)) params.set('start', start);
    }
  }

  if (event) params.set('event', billingTimelineEventToken(event));

  const search = params.toString();
  return `/people/${personId}/billing/timeline${search ? `?${search}` : ''}`;
};

export const buildVobListUrl = ({
  policyId,
  memberId
}: {
  policyId?: string;
  memberId?: string;
}): string => {
  const params = new URLSearchParams();
  if (policyId) params.set('policy_id', policyId);
  params.set('include_excluded_from_analytics_members', 'true');
  if (memberId) params.set('member_id', memberId);

  return `/vob/list?${params.toString()}`;
};
